export default __webpack_public_path__ + "static/media/nerds_logo.818cd216.jpg";